import { LocationState } from 'types/tabState';

export const createTabState = (tabGroupId: string, tabId: string, subTab?: number): LocationState => {
    return { tabs: { [tabGroupId]: { main: tabId, ...(subTab !== undefined ? { sub: subTab } : {}) } } };
};
